import { IconProp } from "@fortawesome/fontawesome-svg-core";
import { alpha, Box, Typography, useTheme } from "@mui/material";
import { map } from "lodash-es";
import React from "react";
import { FormattedMessage } from "react-intl";
import { Link } from "react-router-dom";

import VPGMainLogo from "~/images/icons/vpg-icon-CucS85T0_copy.png";
import { Icon } from "~/ui/components";
import { useScreenMd } from "~/utils";

import { FooterList } from "./FooterList";

export const FooterIcons: React.FC = () => {
  const isDesktop = useScreenMd();
  const theme = useTheme();
  const icons: { icon: IconProp; pathname: string }[] = [
    {
      icon: ["fab", "twitter"],
      pathname: "https://www.twitter.com/OfficialVPG",
    },
    {
      icon: ["fab", "facebook"],
      pathname: "https://www.facebook.com/VirtualProGaming",
    },
    {
      icon: ["fab", "twitch"],
      pathname: "https://www.twitch.tv/vpgesports",
    },
    {
      icon: ["fab", "youtube"],
      pathname: "https://www.youtube.com/virtualprogaming",
    },
  ];

  return (
    <Box
      display="flex"
      flexDirection={isDesktop ? "column" : "row"}
      alignItems={isDesktop ? "flex-start" : "center"}
      gap={isDesktop ? 2 : 4}
      sx={{
        bgcolor: alpha(theme.palette.background.default, 0.9),
        borderRadius: 2,
        boxShadow: 1,
        p: 2,
        border: `1px solid ${alpha(theme.palette.primary.main, 0.1)}`,
        width: { xs: "100%", md: "auto" },
        px: { xs: 0, md: 2 },
      }}
    >
      <Link to="/" style={{ display: "block" }}>
        <Box
          component="img"
          src={VPGMainLogo}
          alt="VPG Logo"
          sx={{
            width: { xs: "11em", sm: "13em", md: "15em" },
            height: { xs: "3.1em", sm: "auto" },
            maxWidth: "100%",
            display: "block",
            mx: "auto",
            my: 2,
            ml: { xs: 1, sm: 0, md: 0 },
          }}
        />
      </Link>
      <Box display="flex" flexDirection="column" gap={1}>
        <Typography
          variant="body2"
          color="text.secondary"
          sx={{ fontWeight: 500, mb: 1, pr: { xs: 2, sm: 0 } }}
        >
          <FormattedMessage
            defaultMessage="info@virtualprogaming.com"
            id="VxrrX1"
          />
        </Typography>
        <Box
          component="ul"
          display="flex"
          flexDirection="row"
          alignItems="center"
          gap={2}
          sx={{
            listStyle: "none",
            p: 0,
            m: 0,
          }}
        >
          {map(icons, (icon, i) => (
            <Box component="li" key={i}>
              <Link
                to={{ pathname: icon.pathname }}
                target="_blank"
                style={{ color: theme.palette.text.secondary }}
              >
                <Icon
                  icon={icon.icon}
                  size="lg"
                  cursor="pointer"
                  style={{
                    color: theme.palette.primary.main,
                    transition: "color 0.2s",
                  }}
                  onMouseOver={(e) =>
                    (e.currentTarget.style.color = theme.palette.secondary.main)
                  }
                  onMouseOut={(e) =>
                    (e.currentTarget.style.color = theme.palette.primary.main)
                  }
                />
              </Link>
            </Box>
          ))}
        </Box>
        {isDesktop && <FooterList />}
      </Box>
    </Box>
  );
};
